export class Content {
    key: string;
    kind?: Kind;
    value: any;

    public constructor(init?: Partial<Content>) {
        Object.assign(this, init);
    }
}

export enum Kind {
    Text = 0,
    Markdown,
    Image,
    FaqCategory,
    ItemsList,
}
